import { Box } from "@mui/material"
import {
  FocusContext,
  setFocus,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation"
import React, { ReactNode, useCallback, useRef } from "react"

import { DGText } from "../../../components/common/DGText"
import { GenericButton } from "../../../components/common/GenericButton"
import { ChevronRight } from "../../../components/common/icons/ChevronRight"
import { ClockIcon } from "../../../components/common/icons/ClockIcon"
import { HeadphonesIcon } from "../../../components/common/icons/HeadphonesIcon"
import { StarIcon } from "../../../components/common/icons/StarIcon"
import useTranslate, { Namespaces } from "../../../hooks/use-translate"
import { appStore } from "../../../store/AppStore"
import { focusStore } from "../../../store/FocusStore"
import { TranslationKey } from "../../../types"
import { CuratedContentSlugV2, s } from "../../../utilities/common"
import { theme, TI } from "../../../utilities/theme"

type TEmptyState = {
  titleKey: TranslationKey<Namespaces.Default>
  descriptionKey: TranslationKey<Namespaces.Default>
  icon: ReactNode
}
export const emptyStates: TEmptyState[] = [
  {
    titleKey: "tv__myStage_headline_favourite_videos",
    descriptionKey: "myStage__explanation_favoriteWorks",
    icon: <StarIcon />,
  },
  {
    titleKey: "tv__myStage_headline_recent_videos",
    descriptionKey: "myStage__explanation_nothingPlayed",
    icon: <ClockIcon />,
  },
  {
    titleKey: "tv__myStage_headline_favourite_albums",
    descriptionKey: "myStage__explanation_favoriteAlbums",
    icon: <StarIcon />,
  },
  {
    titleKey: "tv__myStage_headline_recent_albums",
    descriptionKey: "tv__myStage_explanation_recent_audio",
    icon: <HeadphonesIcon />,
  },
  // FIXME wait translation
  {
    titleKey: "tv__myStage_headline_favourite_playlists",
    descriptionKey: "myStage__explanation_favoritePlaylists",
    icon: <StarIcon />,
  },
]
export const EmptyState = ({ index }: { index: number }) => {
  const t = useTranslate()
  const title = t(emptyStates[index].titleKey)
  const description = t(emptyStates[index].descriptionKey)
  const Icon = useCallback(() => <>{emptyStates[index].icon}</>, [index])
  const { ref, focusKey } = useFocusable()
  const scrollRef = useRef(document.getElementById("root"))
  const setSlug = appStore((state) => state.setSlug)
  const setTabBarSlug = focusStore((state) => state.setTabBarSlug)
  return (
    <FocusContext.Provider value={focusKey}>
      <Box ref={ref}>
        <DGText
          tx={TI.H07tv}
          sx={{
            width: "100%",
            textTransform: "uppercase",
            color: theme.palette.white.main,
            pl: s("96px"),
            mb: s("64px"),
          }}
        >
          {title}
        </DGText>
        <Box
          sx={{
            mt: s("96px"),
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Icon />
          <DGText
            tx={TI.Subheadline02tv}
            sx={{
              mt: s("48px"),
              color: theme.palette.white[70],
              width: s("846px"),
              textAlign: "center",
            }}
          >
            {description}
          </DGText>
          <GenericButton
            ariaLabel={t("signup__browse_the_site")}
            sx={{ mt: s("64px"), mb: s("96px") }}
            onEnterPress={() => {
              setSlug(CuratedContentSlugV2.Search)
              setTabBarSlug(CuratedContentSlugV2.Search)
              setFocus("TABBAR:" + CuratedContentSlugV2.Search)
            }}
            prefScroll
            scroll={{
              scrollRef,
              offsetTop: s(700),
            }}
          >
            <DGText tx={TI.Subheadline07tv}>
              {t("signup__browse_the_site")}
            </DGText>
            <ChevronRight fill={"black"} />
          </GenericButton>
        </Box>
      </Box>
    </FocusContext.Provider>
  )
}
